/* eslint-disable import/no-cycle */
import { capitalizeFirstLetter } from './UtilityFunctions';
import { dailyEngineSettingsOptions } from './constants';
import { STATUS_LIST } from './enums';

function convertOptionKeyToDropdownOption(optionKey) {
  let optionText = optionKey.split('_');
  optionText = optionText.map((text) => capitalizeFirstLetter(text)).join(' ');
  return { key: optionKey, value: optionKey, text: optionText };
}

export const ACCESS_OPTIONS = {
  STATUS: {
    name: 'status',
    options: {
      DRAFT_STATUS: 'draft_status',
      ALL_STATUS: 'all_status',
    },
    get optionsForDropdown() {
      return Object.values(this.options).map((optionKey) => convertOptionKeyToDropdownOption(optionKey));
    },
  },
  CREATED_BY: {
    name: 'createdBy',
    options: {
      SAME_USER: 'same_user',
      ALL_USERS: 'all_users',
    },
    get optionsForDropdown() {
      return Object.values(this.options).map((optionKey) => convertOptionKeyToDropdownOption(optionKey));
    },
  },
  DISABLED_FIELD: {
    name: 'disabledField',
    options: {
      STATUS: 'status',
      ROLE: 'role',
      VENDOR: 'vendor',
      SKILLS: 'skills',
      CERTIFICATIONS: 'certifications',
      APPROVER: 'approver',
      ACCEPTANCE_STATUS: 'acceptance status',
      CHANGE_PASSWORD: 'change password',
      TIME_TO_NEXT_PRIORITY: 'time to next priority',
      PRIORITY: 'priority',
      DESCRIPTION: 'description',
      STRICT_HARD_ASSIGNMENT: 'strict hard assignment',
      STRICT_HARD_START_TIME: 'strict hard start time',
      STOP_ASSET: 'stop and asset',
      TASK_SCHEDULE: 'task schedule',
      TASK_GLOBAL_ATRIBUTES: 'task global attributes',
      TASK_REASSIGNMENT: 'task Reassignment',
    },
    get optionsForUserDropdown() {
      return [
        this.options.VENDOR,
        this.options.ROLE,
        this.options.SKILLS,
        this.options.CERTIFICATIONS,
        this.options.APPROVER,
      ].map((optionKey) => convertOptionKeyToDropdownOption(optionKey));
    },

    get optionsForUserUpdateDropdown() {
      return [
        this.options.VENDOR,
        this.options.ROLE,
        this.options.SKILLS,
        this.options.CERTIFICATIONS,
        this.options.APPROVER,
        this.options.CHANGE_PASSWORD,
        this.options.TASK_REASSIGNMENT,
      ].map((optionKey) => convertOptionKeyToDropdownOption(optionKey));
    },

    get optionsForTaskDropdown() {
      return [
        this.options.STATUS,
        this.options.ACCEPTANCE_STATUS,
        this.options.TIME_TO_NEXT_PRIORITY,
        this.options.PRIORITY,
        this.options.DESCRIPTION,
        this.options.STRICT_HARD_START_TIME,
        this.options.STRICT_HARD_ASSIGNMENT,
        this.options.STOP_ASSET,
        this.options.TASK_SCHEDULE,
        this.options.TASK_GLOBAL_ATRIBUTES,
      ].map((optionKey) => convertOptionKeyToDropdownOption(optionKey));
    },
  },
  ALLOWED_TO_EDIT: {
    name: 'allowedToEdit',
    options: {
      SELF: 'self',
      ALL_USERS: 'all_users',
    },
    get optionsForDropdown() {
      return Object.values(this.options).map((optionKey) => convertOptionKeyToDropdownOption(optionKey));
    },
  },
  ALLOWED_TO_CREATE_USER: {
    name: 'allowedToCreateUser',
    options: {
      ALL_USERS: 'all_users',
    },
    get optionsForDropdown() {
      return Object.values(this.options).map((optionKey) => convertOptionKeyToDropdownOption(optionKey));
    },
  },
};

export const RESOURCE_TYPE = {
  VIEW: 'view',
  FEATURE: 'feature',
  ENTITY: 'entity',
};

export const RESOURCES = {
  VIEW: {
    TASK_VIEW: 'taskView',
    TEAM_VIEW: 'teamView',
    AREA_VIEW: 'areaView',
    TASK_TYPE_VIEW: 'taskTypeView',
    USER_MANAGEMENT_VIEW: 'userManagementView',
    ROLE_MANAGEMENT_VIEW: 'roleManagementView',
    LOGS_VIEW: 'logsView',
    ASSET_MANAGEMENT_VIEW: 'assetManagementView',
    PICKLIST_MANAGEMENT_VIEW: 'picklistManagementView',
    CONTACT_MANAGEMENT_VIEW: 'contactManagementView',
    INSTRUCTION_MANAGEMENT_VIEW: 'instructionManagementView',
    VENDOR_MANAGEMENT_VIEW: 'vendorManagementView',
    FORM_MANAGEMENT_VIEW: 'formManagementView',
    PRIORITIZATION_MANAGEMENT_VIEW: 'prioritizationManagementView',
    ENGINE_SCHEDULE_MANAGEMENT_VIEW: 'engineScheduleManagementView',
    APPROVAL_MATRIX_MANAGEMENT_VIEW: 'approvalMatrixManagementView',
    GLOBAL_ATTRIBUTE_VIEW: 'globalAttributeView',
    ATTACHMENT_MANAGEMENT_VIEW: 'attachmentManagementView',
    EXPORT_MANGEMENT_VIEW: 'exportManagementView',
    REQUEST_VIEW: 'requestView',
    WATCHER_GROUP_MANAGEMENT_VIEW: 'watcherGroupManagementView',
    CUSTOM_REPORTS_VIEW: 'customReportsView',
    FACTORS_MANAGEMENT_VIEW: 'factorsManagementView',
    PRIORITIZATION_MODEL_VIEW: 'prioritizationModelView',
  },
  FEATURE: {
    ROUTING_ENGINE: 'routingEngine',
    PLANNING_ENGINE: 'planningEngine',
    SHOW_UNASSIGNED_USERS: 'showunassigneduser',
    SHOW_MOBILE_ASSET_DOWNLOAD_OPTIONS: 'showmobileassetdonwloadoptions',
    DAILY_SETTINGS_OPTONS: 'dailyenginesettingsoptions',
    SAVE_AS_DRAFT: 'saveasDraft',
    PARENT_TASK_TYPE: 'parentTaskType',
    TRIGGER_TASKS_USING_RULES: 'triggerTasksUsingRules',
    TASK_LIST_VIEW: 'taskListView',
  },
  ENTITY: {
    TASK: 'task',
    TEAM: 'team',
    AREA: 'area',
    TASK_TYPE: 'taskType',
    ROLE: 'role',
    USER: 'user',
    ASSET: 'asset',
    PICKLIST: 'picklist',
    CONTACT: 'contact',
    INSTRUCTION: 'instruction',
    VENDOR: 'vendor',
    FORM: 'form',
    ENGINESCHEDULE: 'engineschedule',
    APPROVAL_MATRIX: 'approvalMatrix',
    GLOBAL_ATTRIBUTE: 'globalAttribute',
    ATTACHMENT: 'attachment',
    WATCHER_GROUP: 'watcherGroup',
    FACTORS: 'factors',
    PRIORITIZATION_MODEL: 'prioritizationModel',
  },
};

export const ENTITY_ACCESS_TYPE = {
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
};

export const DEFAULT_RESOURCE_ACCESS_LEVEL = {
  [RESOURCE_TYPE.VIEW]: {
    [RESOURCES.VIEW.TASK_VIEW]: true,
    [RESOURCES.VIEW.TEAM_VIEW]: true,
    [RESOURCES.VIEW.AREA_VIEW]: true,
    [RESOURCES.VIEW.TASK_TYPE_VIEW]: true,
    [RESOURCES.VIEW.USER_MANAGEMENT_VIEW]: true,
    [RESOURCES.VIEW.LOGS_VIEW]: true,
    [RESOURCES.VIEW.ROLE_MANAGEMENT_VIEW]: true,
    [RESOURCES.VIEW.PICKLIST_MANAGEMENT_VIEW]: true,
    [RESOURCES.VIEW.CONTACT_MANAGEMENT_VIEW]: true,
    [RESOURCES.VIEW.INSTRUCTION_MANAGEMENT_VIEW]: true,
    [RESOURCES.VIEW.VENDOR_MANAGEMENT_VIEW]: true,
    [RESOURCES.VIEW.FORM_MANAGEMENT_VIEW]: true,
    [RESOURCES.VIEW.PRIORITIZATION_MANAGEMENT_VIEW]: false,
    [RESOURCES.VIEW.ENGINE_SCHEDULE_MANAGEMENT_VIEW]: true,
    [RESOURCES.VIEW.APPROVAL_MATRIX_MANAGEMENT_VIEW]: true,
    [RESOURCES.VIEW.GLOBAL_ATTRIBUTE_VIEW]: true,
    [RESOURCES.VIEW.REQUEST_VIEW]: false,
    [RESOURCES.VIEW.WATCHER_GROUP_MANAGEMENT_VIEW]: true,
    [RESOURCES.VIEW.FACTORS_MANAGEMENT_VIEW]: true,
    [RESOURCES.VIEW.PRIORITIZATION_MODEL_VIEW]: true,
  },
  [RESOURCE_TYPE.FEATURE]: {
    [RESOURCES.FEATURE.ROUTING_ENGINE]: true,
    [RESOURCES.FEATURE.PLANNING_ENGINE]: true,
    [RESOURCES.FEATURE.SHOW_UNASSIGNED_USERS]: true,
    [RESOURCES.FEATURE.SHOW_MOBILE_ASSET_DOWNLOAD_OPTIONS]: false,
    [RESOURCES.FEATURE.SAVE_AS_DRAFT]: true,
    [RESOURCES.FEATURE.DAILY_SETTINGS_OPTONS]: dailyEngineSettingsOptions().map((e) => e.value),
    [RESOURCES.FEATURE.PARENT_TASK_TYPE]: true,
    [RESOURCES.FEATURE.TRIGGER_TASKS_USING_RULES]: false,
  },
  [RESOURCE_TYPE.ENTITY]: {
    [RESOURCES.ENTITY.TASK]: {
      [ENTITY_ACCESS_TYPE.CREATE]: {
        [ACCESS_OPTIONS.STATUS.name]: ACCESS_OPTIONS.STATUS.options.ALL_STATUS,
      },
      [ENTITY_ACCESS_TYPE.UPDATE]: {
        criteria: {
          [ACCESS_OPTIONS.CREATED_BY.name]: ACCESS_OPTIONS.CREATED_BY.options.ALL_USERS,
          [ACCESS_OPTIONS.STATUS.name]: ACCESS_OPTIONS.STATUS.options.ALL_STATUS,
        },
        [ACCESS_OPTIONS.DISABLED_FIELD.name]: [],
      },
      [ENTITY_ACCESS_TYPE.DELETE]: {
        criteria: {
          [ACCESS_OPTIONS.CREATED_BY.name]: ACCESS_OPTIONS.CREATED_BY.options.ALL_USERS,
          [ACCESS_OPTIONS.STATUS.name]: ACCESS_OPTIONS.STATUS.options.ALL_STATUS,
        },
      },
    },
    [RESOURCES.ENTITY.TEAM]: {
      [ENTITY_ACCESS_TYPE.CREATE]: true,
      [ENTITY_ACCESS_TYPE.UPDATE]: true,
      [ENTITY_ACCESS_TYPE.DELETE]: true,
    },
    [RESOURCES.ENTITY.AREA]: {
      [ENTITY_ACCESS_TYPE.CREATE]: true,
      [ENTITY_ACCESS_TYPE.UPDATE]: true,
      [ENTITY_ACCESS_TYPE.DELETE]: true,
    },
    [RESOURCES.ENTITY.TASK_TYPE]: {
      [ENTITY_ACCESS_TYPE.CREATE]: true,
      [ENTITY_ACCESS_TYPE.UPDATE]: true,
      [ENTITY_ACCESS_TYPE.DELETE]: true,
    },
    [RESOURCES.ENTITY.ROLE]: {
      [ENTITY_ACCESS_TYPE.CREATE]: true,
      [ENTITY_ACCESS_TYPE.UPDATE]: true,
      [ENTITY_ACCESS_TYPE.DELETE]: true,
    },
    [RESOURCES.ENTITY.USER]: {
      [ENTITY_ACCESS_TYPE.UPDATE]: {
        [ACCESS_OPTIONS.DISABLED_FIELD.name]: [],
        criteria: {
          [ACCESS_OPTIONS.ALLOWED_TO_EDIT.name]: ACCESS_OPTIONS.ALLOWED_TO_EDIT.options.ALL_USERS,
        },
      },
      [ENTITY_ACCESS_TYPE.CREATE]: {
        [ACCESS_OPTIONS.DISABLED_FIELD.name]: [],
        criteria: {
          [ACCESS_OPTIONS.ALLOWED_TO_EDIT.name]: ACCESS_OPTIONS.ALLOWED_TO_EDIT.options.ALL_USERS,
        },
      },
      [ENTITY_ACCESS_TYPE.DELETE]: {
        [ACCESS_OPTIONS.DISABLED_FIELD.name]: [],
        criteria: {
          [ACCESS_OPTIONS.ALLOWED_TO_EDIT.name]: ACCESS_OPTIONS.ALLOWED_TO_EDIT.options.ALL_USERS,
        },
      },
    },
    [RESOURCES.ENTITY.ASSET]: {
      [ENTITY_ACCESS_TYPE.CREATE]: true,
      [ENTITY_ACCESS_TYPE.UPDATE]: true,
      [ENTITY_ACCESS_TYPE.DELETE]: true,
    },
    [RESOURCES.ENTITY.PICKLIST]: {
      [ENTITY_ACCESS_TYPE.CREATE]: true,
      [ENTITY_ACCESS_TYPE.UPDATE]: true,
      [ENTITY_ACCESS_TYPE.DELETE]: true,
    },
    [RESOURCES.ENTITY.CONTACT]: {
      [ENTITY_ACCESS_TYPE.CREATE]: true,
      [ENTITY_ACCESS_TYPE.UPDATE]: true,
      [ENTITY_ACCESS_TYPE.DELETE]: true,
    },
    [RESOURCES.ENTITY.INSTRUCTION]: {
      [ENTITY_ACCESS_TYPE.CREATE]: true,
      [ENTITY_ACCESS_TYPE.UPDATE]: true,
      [ENTITY_ACCESS_TYPE.DELETE]: true,
    },
    [RESOURCES.ENTITY.VENDOR]: {
      [ENTITY_ACCESS_TYPE.CREATE]: true,
      [ENTITY_ACCESS_TYPE.UPDATE]: true,
      [ENTITY_ACCESS_TYPE.DELETE]: true,
    },
    [RESOURCES.ENTITY.FORM]: {
      [ENTITY_ACCESS_TYPE.CREATE]: true,
      [ENTITY_ACCESS_TYPE.UPDATE]: true,
      [ENTITY_ACCESS_TYPE.DELETE]: true,
    },
    [RESOURCES.ENTITY.ENGINESCHEDULE]: {
      [ENTITY_ACCESS_TYPE.CREATE]: true,
      [ENTITY_ACCESS_TYPE.UPDATE]: true,
      [ENTITY_ACCESS_TYPE.DELETE]: true,
    },
    [RESOURCES.ENTITY.APPROVAL_MATRIX]: {
      [ENTITY_ACCESS_TYPE.CREATE]: true,
      [ENTITY_ACCESS_TYPE.UPDATE]: true,
      [ENTITY_ACCESS_TYPE.DELETE]: true,
    },
    [RESOURCES.ENTITY.GLOBAL_ATTRIBUTE]: {
      [ENTITY_ACCESS_TYPE.CREATE]: true,
      [ENTITY_ACCESS_TYPE.UPDATE]: true,
      [ENTITY_ACCESS_TYPE.DELETE]: true,
    },
    [RESOURCES.ENTITY.WATCHER_GROUP]: {
      [ENTITY_ACCESS_TYPE.CREATE]: true,
      [ENTITY_ACCESS_TYPE.UPDATE]: true,
      [ENTITY_ACCESS_TYPE.DELETE]: true,
    },
    [RESOURCES.ENTITY.FACTORS]: {
      [ENTITY_ACCESS_TYPE.CREATE]: true,
      [ENTITY_ACCESS_TYPE.UPDATE]: true,
      [ENTITY_ACCESS_TYPE.DELETE]: true,
    },
    [RESOURCES.ENTITY.PRIORITIZATION_MODEL]: {
      [ENTITY_ACCESS_TYPE.CREATE]: true,
      [ENTITY_ACCESS_TYPE.UPDATE]: true,
      [ENTITY_ACCESS_TYPE.DELETE]: true,
    },
  },
};

export const VENDOR_RESOURCE_ACCESS_LEVEL = {
  [RESOURCE_TYPE.VIEW]: {
    [RESOURCES.VIEW.TASK_VIEW]: true,
    [RESOURCES.VIEW.TEAM_VIEW]: true,
  },
  [RESOURCE_TYPE.FEATURE]: {
    [RESOURCES.FEATURE.PLANNING_ENGINE]: false,
    [RESOURCES.FEATURE.ROUTING_ENGINE]: false,
    [RESOURCES.FEATURE.SHOW_UNASSIGNED_USERS]: false,
    [RESOURCES.FEATURE.SHOW_MOBILE_ASSET_DOWNLOAD_OPTIONS]: false,
    [RESOURCES.FEATURE.PARENT_TASK_TYPE]: true,
    [RESOURCES.FEATURE.TRIGGER_TASKS_USING_RULES]: false,
  },
  [RESOURCE_TYPE.ENTITY]: {
    [RESOURCES.ENTITY.TASK]: {
      [ENTITY_ACCESS_TYPE.CREATE]: {
        [ACCESS_OPTIONS.STATUS.name]: ACCESS_OPTIONS.STATUS.options.DRAFT_STATUS,
      },
      [ENTITY_ACCESS_TYPE.UPDATE]: {
        [ACCESS_OPTIONS.STATUS.name]: ACCESS_OPTIONS.STATUS.options.ALL_STATUS,
        [ACCESS_OPTIONS.CREATED_BY.name]: ACCESS_OPTIONS.CREATED_BY.options.ALL_USERS,
        [ACCESS_OPTIONS.DISABLED_FIELD.name]: [],
      },
      [ENTITY_ACCESS_TYPE.DELETE]: {
        [ACCESS_OPTIONS.STATUS.name]: ACCESS_OPTIONS.STATUS.options.ALL_STATUS,
        [ACCESS_OPTIONS.CREATED_BY.name]: ACCESS_OPTIONS.CREATED_BY.options.ALL_USERS,
      },
    },
    [RESOURCES.ENTITY.TEAM]: {
      [ENTITY_ACCESS_TYPE.CREATE]: true,
      [ENTITY_ACCESS_TYPE.UPDATE]: true,
      [ENTITY_ACCESS_TYPE.DELETE]: true,
    },
  },
};

export const DEFAULT_ROLE = {
  name: '',
  access: DEFAULT_RESOURCE_ACCESS_LEVEL,
};

export const DEFAULT_VENDOR_ROLE = {
  name: '',
  access: VENDOR_RESOURCE_ACCESS_LEVEL,
};

export const ACCESS_OPTION_FUNCTION = {
  [RESOURCES.ENTITY.TASK]: {
    [ACCESS_OPTIONS.STATUS.name]: ({ entity, accessOptionValue }) => {
      switch (accessOptionValue) {
        case ACCESS_OPTIONS.STATUS.options.DRAFT_STATUS: {
          return entity.status === STATUS_LIST.DRAFT.key;
        }
        case ACCESS_OPTIONS.STATUS.options.ALL_STATUS: {
          return true;
        }
        default: {
          return false;
        }
      }
    },
    [ACCESS_OPTIONS.CREATED_BY.name]: ({ entity, accessOptionValue, loggedInUser }) => {
      switch (accessOptionValue) {
        case ACCESS_OPTIONS.CREATED_BY.options.SAME_USER: {
          return entity.createdBy === loggedInUser.userName;
        }
        case ACCESS_OPTIONS.CREATED_BY.options.ALL_USERS: {
          return true;
        }
        default: {
          return false;
        }
      }
    },
  },
  [RESOURCES.ENTITY.USER]: {
    [ACCESS_OPTIONS.ALLOWED_TO_EDIT.name]: ({ entity, accessOptionValue, loggedInUser }) => {
      switch (accessOptionValue) {
        case ACCESS_OPTIONS.ALLOWED_TO_EDIT.options.SELF: {
          return entity.userName === loggedInUser.userName;
        }
        case ACCESS_OPTIONS.ALLOWED_TO_EDIT.options.ALL_USERS: {
          return true;
        }
        default: {
          return false;
        }
      }
    },
  },
};
